import { MenuItem, Modal, Select } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Styles from "./LoiTemplate.module.css";
import { Close } from "@mui/icons-material";
import { ReactComponent as EditIcon } from "../../../../assets/images/editIcon.svg";
import { ReactComponent as KeyboardArrowDown } from "../../../../assets/images/dropdown.svg";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  generateMemberDetails,
  updateMemberDetails,
} from "../../../../Services/CompanyAdmin/AllApiAdmin";

const LoiTemplate = ({ open, handleClose, heading }) => {
  let currDate = new Date().toLocaleDateString("en-GB");

  const getInitialState = () => {
    const savedData = localStorage.getItem("loiTemplateData");
    if (savedData) {
      try {
        return JSON.parse(savedData);
      } catch (error) {
      }
    }
    return {
      companyName: "Insert Company Name",
      chiefEngg: "Chief Engineer",
      powerPurchase: "Power Purchase",
      stateDiscom: "State Discom",
      insAddress: "Insert Address",
      nameDes: "Name/Designation",
      dept: "Department",
      loaFormat: "LOI Number Format",
      generatlTermsCond:
        "As per the Framework Agreement/As per the Listing Document",
      date: currDate,
      endNameandDes: "Name and Designation",
      copyText: "Inset Details",
      remarks: [],
      docType: "loi_document",
      productType: "Banking",
    };
  };

  const initialState = getInitialState();

  const [companyName, setCompanyName] = useState(initialState.companyName);
  const [chiefEngg, setChiefEngg] = useState(initialState.chiefEngg);
  const [powerPurchase, setPowerPurchase] = useState(
    initialState.powerPurchase
  );
  const [stateDiscom, setStateDiscom] = useState(initialState.stateDiscom);
  const [insAddress, setInsAddress] = useState(initialState.insAddress);
  const [nameDes, setNameDes] = useState(initialState.nameDes);
  const [dept, setDept] = useState(initialState.dept);
  const [loaFormat, setLoaFormat] = useState(initialState.loaFormat);
  const [generatlTermsCond, setGeneralTermsCond] = useState(
    initialState.generatlTermsCond
  );
  const [date, setDate] = useState(initialState.date);
  const [addPoint, setAddPoint] = useState("");
  const [endNameandDes, setEndNameandDes] = useState(
    initialState.endNameandDes
  );
  const [copyText, setCopyText] = useState(initialState.copyText);

  const [logo, setLogo] = useState("");
  const [logoId, setLogoId] = useState("");

  const [fileData, setFileData] = useState("");

  const [remarks, setRemarks] = useState(initialState.remarks);

  const [editActive, setEditActive] = useState(false);
  const [editId, setEditId] = useState("");
  const [defLogo, setDefLogo] = useState("");
  const [loiHtml, setLoiHtml] = useState("");
  const [docType, setDocType] = useState(initialState.docType);
  const [productType, setProductType] = useState(initialState.productType);
  const [submitLoading, setSubmitLoading] = useState(false);

  const authUser = useSelector((state) => state.persistedReducer);

  useEffect(() => {
    const formData = {
      companyName,
      chiefEngg,
      powerPurchase,
      stateDiscom,
      insAddress,
      nameDes,
      dept,
      loaFormat,
      generatlTermsCond,
      date,
      endNameandDes,
      copyText,
      remarks,
      docType,
      productType,
    };
    localStorage.setItem("loiTemplateData", JSON.stringify(formData));
  }, [
    companyName,
    chiefEngg,
    powerPurchase,
    stateDiscom,
    insAddress,
    nameDes,
    dept,
    loaFormat,
    generatlTermsCond,
    date,
    endNameandDes,
    copyText,
    remarks,
    docType,
    productType,
  ]);

  useEffect(() => {
    if (open) {
      const savedData = localStorage.getItem("loiTemplateData");
      if (savedData) {
        try {
          const parsedData = JSON.parse(savedData);
          setCompanyName(parsedData.companyName || "Insert Company Name");
          setChiefEngg(parsedData.chiefEngg || "Chief Engineer");
          setPowerPurchase(parsedData.powerPurchase || "Power Purchase");
          setStateDiscom(parsedData.stateDiscom || "State Discom");
          setInsAddress(parsedData.insAddress || "Insert Address");
          setNameDes(parsedData.nameDes || "Name/Designation");
          setDept(parsedData.dept || "Department");
          setLoaFormat(parsedData.loaFormat || "LOI Number Format");
          setGeneralTermsCond(
            parsedData.generatlTermsCond ||
              "As per the Framework Agreement/As per the Listing Document"
          );
          setDate(parsedData.date || new Date().toLocaleDateString("en-GB"));
          setEndNameandDes(parsedData.endNameandDes || "Name and Designation");
          setCopyText(parsedData.copyText || "Inset Details");
          setRemarks(parsedData.remarks || []);
          setDocType(parsedData.docType || "loi_document");
          setProductType(parsedData.productType || "Banking");
        } catch (error) {
        }
      }
    }
  }, [open]);

  useEffect(() => {
    const fetchInitialPreview = async () => {
      if (open) {
        try {
          let formData = {
            templateName: docType, // loi_document
            type: productType, // Banking
            map: {},
          };

          if (productType === "Banking") {
            formData.map = {
              myCompanyName: companyName,
              chiefEngineer: chiefEngg,
              recipientName: nameDes,
              recipientDept: dept,
              counterpartyOrgAddr: insAddress,
              loaNumber: loaFormat,
              loaDate: date,
              electricityCompanyName: stateDiscom,
              myListing: companyName,
              counterListing: nameDes,
            };
          } else if (productType === "Bilateral" || productType === "BSRA") {
            formData.map = {
              companyName: companyName,
              chiefEngineer: chiefEngg,
              recipientName: nameDes,
              recipientDept: dept,
              counterpartyOrgAddr: insAddress,
              loaNumber: loaFormat,
              loaDate: date,
              electricityCompanyName: stateDiscom,
              myListing: companyName,
              counterListing: nameDes,
            };
          }

          const response = await generateMemberDetails(formData);
          setLoiHtml(response?.data || response);
        } catch (err) {
        }
      }
    };

    fetchInitialPreview();
  }, [
    open,
    docType,
    productType,
    companyName,
    chiefEngg,
    nameDes,
    dept,
    insAddress,
    loaFormat,
    date,
    stateDiscom,
  ]);
  const handleDocTypeChange = (event) => {
    setDocType(event.target.value);
  };

  const handleProductTypeChange = (event) => {
    setProductType(event.target.value);
  };

  const handleAddRemark = () => {
    if (editActive) {
      remarks[editId] = addPoint;
      setAddPoint("");
      setEditActive(false);
      return;
    }
    if (addPoint?.length === 0) {
      return;
    }
    setRemarks((prev) => [...prev, addPoint]);
    setAddPoint("");
    setEditActive(false);
  };

  const handleLogoImage = (value) => {
    return URL.createObjectURL(value);
  };
  const handleEditRem = (data, index) => {
    setEditId(index);
    setEditActive(true);
    setAddPoint(data);
  };

  const handleDelRem = (index) => {
    let newAr = remarks.slice(0, index).concat(remarks.slice(index + 1));
    setRemarks(newAr);
    setAddPoint("");
  };

  const handleDateFormat = (value) => {
    setDate(value);
  };
  function HtmlRenderer({ htmlString }) {
    const iframeRef = useRef(null);
    const [iframeHeight, setIframeHeight] = useState("64vh");

    useEffect(() => {
      const iframe = iframeRef.current;

      const updateHeight = () => {
        try {
          const iframeDoc =
            iframe.contentDocument || iframe.contentWindow.document;
          if (iframeDoc) {
            const body = iframeDoc.body;
            const html = iframeDoc.documentElement;
            const height = Math.max(
              body.scrollHeight,
              body.offsetHeight,
              html.clientHeight,
              html.scrollHeight,
              html.offsetHeight
            );
            setIframeHeight(height + "px");
          }
        } catch (e) {}
      };

      if (iframe) {
        iframe.addEventListener("load", updateHeight);
      }

      updateHeight();

      return () => {
        if (iframe) {
          iframe.removeEventListener("load", updateHeight);
        }
      };
    }, [htmlString]);

    return (
      <div className={Styles.scrollWrapper}>
        <iframe
          ref={iframeRef}
          srcDoc={htmlString}
          title="LOI Preview"
          scrolling="no"
          style={{
            width: "100%",
            height: iframeHeight,
            border: "none",
            overflow: "hidden",
          }}
        />
      </div>
    );
  }

  const handleFetchLoi = async () => {
    try {
      let formData = {
        templateName: docType, // LOI / LOA / AGREEMENT
        type: productType, // BANKING / BSB / BSRA
        map: {},
      };

      if (productType === "Banking") {
        formData.map = {
          myCompanyName: companyName,
          chiefEngineer: chiefEngg,
          recipientName: nameDes,
          recipientDept: dept,
          counterpartyOrgAddr: insAddress,
          loaNumber: loaFormat,
          loaDate: date,
          electricityCompanyName: stateDiscom,
          myListing: companyName,
          counterListing: nameDes,
        };
      } else if (productType === "Bilateral" || productType === "BSRA") {
        formData.map = {
          companyName: companyName,
          chiefEngineer: chiefEngg,
          recipientName: nameDes,
          recipientDept: dept,
          counterpartyOrgAddr: insAddress,
          loaNumber: loaFormat,
          loaDate: date,
          electricityCompanyName: stateDiscom,
          myListing: companyName,
          counterListing: nameDes,
        };
      }

      const response = await generateMemberDetails(formData);
      setLoiHtml(response?.data || response);
    } catch (err) {
    }
  };

  const validateForm = () => {
    const requiredFields = [
      {
        value: companyName,
        name: "Company Name",
        defaultValue: "Insert Company Name",
      },
      {
        value: chiefEngg,
        name: "Chief Engineer",
        defaultValue: "Chief Engineer",
      },
      {
        value: nameDes,
        name: "Name/Designation",
        defaultValue: "Name/Designation",
      },
      {
        value: stateDiscom,
        name: "State Discom",
        defaultValue: "State Discom",
      },
      {
        value: insAddress,
        name: "Address",
        defaultValue: "Insert Address",
      },
      {
        value: dept,
        name: "Department",
        defaultValue: "Department",
      },
      {
        value: loaFormat,
        name: "LOI Number Format",
        defaultValue: "LOI Number Format",
      },
    ];

    const emptyFields = requiredFields.filter(
      (field) =>
        !field.value ||
        field.value.trim() === "" ||
        field.value === field.defaultValue
    );

    if (emptyFields.length > 0) {
      const fieldNames = emptyFields.map((f) => f.name).join(", ");
      toast.error(`Please fill the following required fields: ${fieldNames}`);
      return false;
    }

    if (!date) {
      toast.error("Please select a valid date");
      return false;
    }

    return true;
  };

  const handleSubmitTemplate = async () => {
    try {
      if (!validateForm()) {
        return;
      }

      if (!authUser?.user?.user?.userId) {
        toast.error("User information not found. Please login again.");
        return;
      }

      setSubmitLoading(true);

      let formData = {
        docType,
        productType,
        chiefEngineer: chiefEngg,
        powerPurchase,
        stateDiscom,
        address: insAddress,
        recipientName: nameDes,
        recipientDept: dept,
        loaNumber: loaFormat,
        generalTermsConditions: generatlTermsCond,
        issueDate: date,
        endNameDesignation: endNameandDes,
        remarks,
      };

      // Add company name based on product type
      if (productType === "Banking") {
        formData.myCompanyName = companyName;
      } else if (productType === "Bilateral" || productType === "BSRA") {
        formData.companyName = companyName;
      }

      const userId = authUser?.user?.user?.userId;
      const companyId = authUser?.user?.company?.companyId;
      const role = authUser?.userType;

      const consumerId = authUser?.user?.consumers?.[0]?.consumerId;
      const generatorId = authUser?.user?.generators?.[0]?.generatorId;

      const apiParams = {
        userId,
        companyId,
        role,
      };

      if (consumerId) apiParams.consumerId = consumerId;
      if (generatorId) apiParams.generatorId = generatorId;

      const response = await updateMemberDetails(formData, apiParams);

      if (response?.success || response?.data) {
        toast.success("Template submitted successfully!");
        handleClose();
      } else {
        throw new Error(response?.message || "Failed to submit template");
      }
    } catch (error) {
      toast.error("Error submitting template. Please try again.");
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={Styles.modalContainer}>
          <div className={Styles.modalHeading}>
            <div>Generate Intent </div>
            <div onClick={handleClose} style={{ cursor: "pointer" }}>
              <Close />
            </div>
          </div>
          <div className={Styles.generationSection}>
            <div className={`${Styles.inputAgrCon}`}>
              <div className={Styles.detailsHead}>
                <span>Enter Details</span>
              </div>

              <div className={Styles.InputContainer}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {fileData && !logo && (
                    <img
                      style={{
                        height: "50px",
                        width: "100px",
                        objectFit: "contain",
                      }}
                      src={`data:image/png;base64,${fileData}`}
                      alt=""
                    />
                  )}
                </div>
                <div className={Styles.eachInputSec}>
                  <div>Product Type:</div>
                  <div style={{ width: "63%" }}>
                    <Select
                      value={productType}
                      onChange={handleProductTypeChange}
                      displayEmpty
                      size="small"
                      className={Styles.customSelect}
                      IconComponent={KeyboardArrowDown}
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <span className={Styles.placeholder}>
                              Product Type
                            </span>
                          );
                        }
                        return (
                          <span
                            style={{
                              fontSize: "14px",
                              color: "var(--fifth-color-text)",
                            }}
                          >
                            {selected}
                          </span>
                        );
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            "& .MuiMenuItem-root": {
                              fontSize: "14px",
                              color: "var(--fifth-color-text)",
                              fontWeight: 500,
                              "&:hover": {
                                backgroundColor: "#f5f5f9",
                              },
                            },
                          },
                        },
                      }}
                    >
                      <MenuItem value="Banking">Banking</MenuItem>
                      <MenuItem value="Bilateral">Buy/Sell</MenuItem>
                      {/* <MenuItem value="BSRA">Reverse Auction</MenuItem> */}
                    </Select>
                  </div>
                </div>
                {/* <div className={Styles.eachInputSec}>
                  <div>Upload Logo:</div>
                  <label htmlFor="logoUpload" className={Styles.uploadLabel}>
                    <div className={Styles.iconWrapper}>
                      <Upload
                        width="28px"
                        height="28px"
                        display="flex"
                        justifyContent="right"
                      />
                    </div>
                    <span className={Styles.spanUpload}>Upload Logo</span>
                  </label>

                  <input
                    type="file"
                    id="logoUpload"
                    accept="image/*"
                    className={Styles.fileInput}
                    onChange={(e) => handleFileUpload(e)}
                  />

                  {logo && (
                    <div>
                      <img
                        src={handleLogoImage(logo)}
                        style={{
                          height: "100px",
                          width: "100px",
                          objectFit: "contain",
                          marginTop: "10px",
                        }}
                        alt="preview"
                      />
                    </div>
                  )}
                </div> */}

                <div className={Styles.eachInputSec}>
                  <div>Company Name:</div>
                  <input
                    type="text"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                  />
                </div>
                <div className={Styles.eachInputSec}>
                  <div> Chief Engineer:</div>
                  <input
                    type="text"
                    value={chiefEngg}
                    onChange={(e) => setChiefEngg(e.target.value)}
                  />
                </div>
                {/* <div className={Styles.eachInputSec}>
                  <div>Power Purchase</div>
                  <input
                    type="text"
                    value={powerPurchase}
                    onChange={(e) => setPowerPurchase(e.target.value)}
                  />
                </div> */}
                <div className={Styles.eachInputSec}>
                  <div> Name/Designation</div>
                  <input
                    type="text"
                    value={nameDes}
                    onChange={(e) => setNameDes(e.target.value)}
                  />
                </div>
                <div className={Styles.eachInputSec}>
                  <div>State Discom</div>
                  <input
                    type="text"
                    value={stateDiscom}
                    onChange={(e) => setStateDiscom(e.target.value)}
                  />
                </div>
                <div className={Styles.eachInputSec}>
                  <div>Insert Address</div>
                  <input
                    type="text"
                    value={insAddress}
                    onChange={(e) => setInsAddress(e.target.value)}
                  />
                </div>
                {/* <div className={Styles.eachInputSec}>
                  <div> Name/Designation</div>
                  <input
                    type="text"
                    value={nameDes}
                    onChange={(e) => setNameDes(e.target.value)}
                  />
                </div> */}
                <div className={Styles.eachInputSec}>
                  <div>Department</div>
                  <input
                    type="text"
                    value={dept}
                    onChange={(e) => setDept(e.target.value)}
                  />
                </div>
                <div className={Styles.eachInputSec}>
                  <div>Insert LOI Number :- </div>
                  <input
                    type="text"
                    value={loaFormat}
                    onChange={(e) => setLoaFormat(e.target.value)}
                  />
                </div>
                <div className={Styles.eachInputSec}>
                  <div>General Terms & Conditions :- </div>
                  <input
                    type="text"
                    value={generatlTermsCond}
                    onChange={(e) => setGeneralTermsCond(e.target.value)}
                  />
                </div>
                {/* <div className={Styles.eachInputSec}>
                  <div>Enter Date :- </div>
                  <input
                    type="date"
                    value={date}
                    onChange={(e) => handleDateFormat(e.target.value)}
                  />
                </div> */}
                {/* <div className={Styles.eachInputSec}>
                  <div>End Text :- Name and Designation</div>
                  <input
                    type="text"
                    value={endNameandDes}
                    onChange={(e) => setEndNameandDes(e.target.value)}
                  />
                </div> */}
                {/* <div className={Styles.eachInputSec}>
                  <div>Copy to :- </div>
                  <input
                    type="text"
                    value={copyText}
                    onChange={(e) => setCopyText(e.target.value)}
                  />
                </div> */}
                <div className={Styles.eachInputSec}>
                  <div>Remark :- Add More points</div>
                  <input
                    type="text"
                    placeholder="Add More Remarks"
                    value={addPoint}
                    onChange={(e) => setAddPoint(e.target.value)}
                  />
                </div>
                <div className={Styles.buttonArea}>
                  <div
                    className={Styles.addRemarkButton}
                    onClick={handleAddRemark}
                  >
                    {editActive ? "Edit" : "Add"} Remark
                  </div>

                  {editActive && (
                    <div
                      className={Styles.cancelButton2}
                      onClick={() => {
                        setEditActive(false);
                        setAddPoint("");
                      }}
                    >
                      Cancel
                    </div>
                  )}
                </div>
                <div className={Styles.remarkContainer}>
                  {remarks?.map((ele, index) => (
                    <div className={Styles.eachRemarksCont}>
                      <div>{ele?.substring(0, 50)}...</div>
                      {!editActive && (
                        <div className={Styles.iconsContainer}>
                          <div onClick={() => handleEditRem(ele, index)}>
                            <EditIcon
                              style={{ color: "black", fontSize: "14px" }}
                            />
                          </div>
                          <div onClick={() => handleDelRem(index)}>
                            <Close style={{ color: "red", fontSize: "14px" }} />
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className={Styles.agrDisplaySec}>
              <div>
                <div
                  style={{ display: "flex", gap: "10px", alignItems: "center" }}
                >
                  <div
                    onClick={() => handleFetchLoi()}
                    style={{ cursor: "pointer" }}
                  >
                    Preview
                  </div>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <span>DocType:</span>
                  <Select
                    value={docType}
                    onChange={handleDocTypeChange}
                    size="small"
                    className={Styles.customSelect}
                    IconComponent={KeyboardArrowDown}
                    style={{ minWidth: 150 }}
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <span style={{ color: "#999", fontSize: "14px" }}>
                            Select DocType
                          </span>
                        );
                      }
                      return (
                        <span
                          style={{
                            fontSize: "14px",
                            color: "var(--fifth-color-text)",
                          }}
                        >
                          {selected}
                        </span>
                      );
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          "& .MuiMenuItem-root": {
                            fontSize: "14px",
                            color: "var(--fifth-color-text)",
                            fontWeight: 500,
                            "&:hover": {
                              backgroundColor: "#f5f5f9",
                            },
                          },
                        },
                      },
                    }}
                  >
                    <MenuItem value="loi_document">LOI</MenuItem>
                    <MenuItem value="loa_document">LOA</MenuItem>
                    {/* <MenuItem value="AGREEMENT">Agreement</MenuItem> */}
                  </Select>
                </div>
              </div>
              <span
                className={Styles.prevBtn}
                style={{ width: "99%", border: "none" }}
              >
                {<HtmlRenderer htmlString={loiHtml} />}
              </span>
            </div>
          </div>
          <div className={Styles.btnSubmit}>
            <div onClick={handleClose} className={Styles.cancelButton2}>
              Cancel
            </div>
            <div
              onClick={handleSubmitTemplate}
              style={{
                cursor: submitLoading ? "not-allowed" : "pointer",
                opacity: submitLoading ? 0.6 : 1,
              }}
            >
              {submitLoading ? "Submitting..." : "Submit"}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default LoiTemplate;
